{
  "评测：一个成功率背后藏了什么 · 物理AI实验室 Lab 1.8": {
    "en": "Evaluation: what one success rate hides · Physical AI Lab 1.8",
    "ja": "評価：一つの成功率の裏にあるもの · Physical AI Lab 1.8"
  },
  "一个成功率背后藏了什么": {
    "en": "What one success rate hides",
    "ja": "一つの成功率が隠すもの"
  },
  "同一个抓碗任务，10 个起始状态 × 3 种条件，共 30 次。每一格是一次真实的回合；拆开看，比一个总数多说很多。": {
    "en": "Grasping a bowl: 10 initial states × 3 conditions, 30 trials. Each cell is a real episode; broken down, they say more than a total.",
    "ja": "ボウル把持を初期状態 10 × 条件 3、計 30 回。各マスは実際の1エピソード。分けて見れば、合計より多くを語る。"
  },
  "30 次结果 · 10 个起始状态 × 3 种条件": {
    "en": "30 results · 10 initial states × 3 conditions",
    "ja": "30 回の結果 · 初期状態 10 × 条件 3"
  },
  "净增": {
    "en": "Net change",
    "ja": "純増"
  },
  "配对拆开 · {0} vs 正常光": {
    "en": "Pairs split · {0} vs normal light",
    "ja": "ペアで分解 · {0} vs 通常光"
  },
  "净增（挪相机 − 正常光）": {
    "en": "Net (camera − normal)",
    "ja": "純増（カメラ − 通常光）"
  },
  "拆开：变好 / 变坏": {
    "en": "Better / worse",
    "ja": "分解：改善 / 悪化"
  },
  "失败里“动作用完”": {
    "en": "Failures out of actions",
    "ja": "失敗のうち「動作切れ」"
  },
  "正常光": {
    "en": "Normal light",
    "ja": "通常光"
  },
  "暗光": {
    "en": "Dim light",
    "ja": "暗い光"
  },
  "挪相机": {
    "en": "Camera moved",
    "ja": "カメラ移動"
  },
  "全部": {
    "en": "All",
    "ja": "すべて"
  },
  "都成功": {
    "en": "Both succeed",
    "ja": "両方成功"
  },
  "变好": {
    "en": "Better",
    "ja": "改善"
  },
  "变坏": {
    "en": "Worse",
    "ja": "悪化"
  },
  "都没完成": {
    "en": "Neither",
    "ja": "両方未達成"
  },
  "配对拆开（不看净增）": {
    "en": "Split into pairs (not the net)",
    "ja": "ペアで分解（純増を見ない）"
  },
  "这一次 · trial": {
    "en": "This trial",
    "ja": "この試行 · trial"
  },
  "起始状态": {
    "en": "Initial state",
    "ja": "初期状態"
  },
  "跳到最后一段运动 ▸": {
    "en": "Jump to the last stretch ▸",
    "ja": "最後の動きへ ▸"
  },
  "数据：robot-reel 压力实验（Apache-2.0）· SmolVLA · LIBERO-spatial 单任务 · 每次最多 160 个动作（8 秒仿真）": {
    "en": "Data: robot-reel stress lab (Apache-2.0) · SmolVLA · one LIBERO-spatial task · at most 160 actions per trial (8 s simulated)",
    "ja": "データ：robot-reel ストレス実験（Apache-2.0）· SmolVLA · LIBERO-spatial 単一タスク · 1回あたり最大 160 動作（シミュレーション 8 秒）"
  },
  "点格子看那一次 · 拖动空白处旋转视角": {
    "en": "Click a cell to see that trial · drag empty space to orbit",
    "ja": "マスをクリックしてその試行を見る · 空いた所をドラッグして視点を回す"
  },
  "起始状态 {0} · 条件 {1}": {
    "en": "Initial state {0} · {1}",
    "ja": "初期状態 {0} · 条件 {1}"
  },
  "动作 {0} / {1} · 仿真 {2} s": {
    "en": "Actions {0} / {1} · sim {2} s",
    "ja": "動作 {0} / {1} · シム {2} s"
  },
  "最后一秒末端还走了 {0}": {
    "en": "Hand moved {0} in the last second",
    "ja": "最後の1秒でも手先は {0} 動いた"
  },
  "按记录回放末端轨迹（20 Hz）": {
    "en": "replaying the recorded hand path (20 Hz)",
    "ja": "記録した手先の軌跡を再生（20 Hz）"
  },
  "SUCCESS · 成功": {
    "en": "SUCCESS",
    "ja": "SUCCESS · 成功"
  },
  "用了 {0} 个动作": {
    "en": "took {0} actions",
    "ja": "{0} 動作で達成"
  },
  "STEP LIMIT · 动作用完": {
    "en": "STEP LIMIT",
    "ja": "STEP LIMIT · 動作切れ"
  },
  "到点被停下，手还在动：不是“做错了停住”，是“没做完”": {
    "en": "stopped at the limit with the hand still moving: not \"stuck on a mistake\", just \"not finished\"",
    "ja": "上限で止められ、手はまだ動いていた。「失敗して止まった」のではなく「終わっていなかった」"
  }
}
